<template>
  <div class="v-full">
    <!-- query的use为oauth时，判断下列oauth2.0的情形 -->
    <template v-if="oauthRedirectData !== null">
      <FeiiplatOauth
        v-if="oauthRedirectData.factory === 'feiiplat'"
        v-model="oauthModalVisible"
        :oauth-data="oauthRedirectData"
        @success="handleOauthLogin"
      />
    </template>
  </div>
</template>
<script>
import FeiiplatOauth from './FeiiplatOauth.vue'
import isEmpty from 'ramda/src/isEmpty'
import global from '@/global'
import { mapActions, mapMutations } from 'vuex'
import { ResponseError } from '@/utils/http/error'
import { PAGE_NAME } from '@/utils/constant'

export default {
  name: 'OauthGroup',
  props: {
    /**
     * @type {
     *    // 一个函数接收一个对象(token为hileia的token, info为用户信息)，返回Promise
     *    function(all: {token, info}) => Promise<unknown>
     * }
     */
    oauthSuccess: {
      props: Function,
      required: true
    },
    /**
     *
     */
    oauthError: {
      /**
       * @type {
       *    //一个函数，接收一个错误
       *    function(err:Error) => unknown
       * }
       */
      props: Function,
      required: false
    }
  },
  components: {
    FeiiplatOauth
  },
  data() {
    return {
      oauthRedirectData: null,
      oauthModalVisible: true
    }
  },
  created() {
    this.validOauthRedirectBack()
  },
  methods: {
    ...mapActions('oauth', [
      'fetchOauthThirdParty',
      'checkVerifyCode',
      'fetchOauthToken'
    ]),
    ...mapActions('user', ['loginFromPlatformToken']),
    ...mapMutations(['setGlobalSpin']),

    defOauthError(err) {
      if (this.oauthError) {
        this.oauthError(err)
      } else if (ResponseError.isResponseError(err)) {
        this.$router.replace({
          name: PAGE_NAME.Exception,
          query: {
            code: err.code,
            msg: err.message
          }
        })
      }
      return err
    },

    async validOauthRedirectBack() {
      // 校验成功，则返回oauth2.0相关的数据
      const { use, factory, token, users, code } = this.$route.query
      // 全量验证
      if (
        use === 'oauth' && // use为oauth时表示第三方登录成功跳转(尚未绑定账号)
        !isEmpty(factory) &&
        !isEmpty(token) &&
        !isEmpty(users)
      ) {
        try {
          // 检查是否合法
          await this.checkVerifyCode(token)
          const { exist: platformUser, new: factoryUser } = JSON.parse(
            global.base64Decode(users.replaceAll(' ', '+'))
          )
          this.oauthRedirectData = {
            use,
            factory,
            platformUser,
            factoryUser,
            token
          }
        } catch (err) {
          this.defOauthError(err)
        }
      }

      if (
        use === 'login' && // use为login时表示第三方登录成功，且已绑定账号
        !isEmpty(code)
      ) {
        try {
          // 检查是否合法
          const platformToken = await this.fetchOauthToken(code)
          this.handleOauthLogin(platformToken)
        } catch (err) {
          this.defOauthError(err)
        }
      }
      return null
    },
    async handleOauthLogin(platformToken) {
      this.setGlobalSpin({ loading: true, tip: '登录中...' })
      try {
        const all = await this.loginFromPlatformToken({ token: platformToken })
        try {
          await this.oauthSuccess(all)
        } catch (_) {}
      } catch (err) {
        this.defOauthError(err)
      } finally {
        this.setGlobalSpin({ loading: false })
      }
    }
  }
}
</script>
